<template>
  <Header style="margin-bottom: 22px">
    <div v-if="isLoadingFilters" class="rating-header__block">
      <div
        v-for="(n, index) in 2"
        :key="index"
        class="ajax__line -round-"
        :style="{ height: '58px', width: '218px', margin: '2px 2px' }"
      />
    </div>
    <div v-else class="rating-header__block">
      <UiNestedFilter
        ref="amoProducts"
        v-model="filter.amoProducts"
        class="rating-header__item -l- -pointer-"
        title="Выбор продукта в АМО"
        :placeholder="placeholderProducts"
        :option="amoProducts"
        @input="changeValue($event, 'amoProducts')"
      />
      <UiSelect
        ref="courseName"
        v-model="filter.courseName"
        class="rating-header__item -l-"
        title="Выбор курса"
        placeholder="Введите курс"
        :option="localCourseStreams"
        :can-unset="false"
        :unset-value="null"
        @input="changeValue($event, 'courseName')"
      />
    </div>
    <div v-if="isLoadingFilters" class="rating-header__block">
      <div
        v-for="(n, index) in 4"
        :key="index"
        class="ajax__line -round-"
        :style="{ height: '58px', width: '128px', margin: '2px 2px' }"
      />
    </div>
    <div v-else class="rating-header__block">
      <UiNumberInput
        v-model="filter.budgetMin"
        class="rating-header__item -s-"
        title="Бюджет"
        before-text="От"
        placeholder="0р"
        :dot-amount="0"
        :differ-zero="true"
        :show-empty="false"
        :allow-minus="true"
        @input="changeValue($event, 'budgetMin')"
      />
      <span class="rating-header__item">-</span>
      <UiNumberInput
        v-model="filter.budgetMax"
        class="rating-header__item -s-"
        title="Бюджет"
        before-text="До"
        placeholder="0р"
        :dot-amount="0"
        :differ-zero="true"
        :show-empty="false"
        :allow-minus="true"
        @input="changeValue($event, 'budgetMax')"
      />
      <UiNumberInput
        v-model="filter.revenueMin"
        class="rating-header__item -s-"
        title="Выручка"
        before-text="От"
        placeholder="0р"
        :dot-amount="0"
        :differ-zero="true"
        :show-empty="false"
        :allow-minus="true"
        @input="changeValue($event, 'revenueMin')"
      />
      <span class="rating-header__item">-</span>
      <UiNumberInput
        v-model="filter.revenueMax"
        class="rating-header__item -s-"
        title="Выручка"
        before-text="До"
        placeholder="0р"
        :dot-amount="0"
        :differ-zero="true"
        :show-empty="false"
        :allow-minus="true"
        @input="changeValue($event, 'revenueMax')"
      />
    </div>
    <div v-if="isLoadingFilters" class="rating-header__block">
      <div
        v-for="(n, index) in 3"
        :key="index"
        class="ajax__line -round-"
        :style="{ height: '58px', width: '220px', margin: '2px 2px' }"
      />
    </div>
    <div v-else class="rating-header__block">
      <UiInput
        v-model="filter.name"
        class="rating-header__item -l-"
        title="Имя участника"
        placeholder="Имя участника"
        @input="changeValue($event, 'name')"
      />
      <UiInput
        v-model="filter.email"
        class="rating-header__item -l-"
        title="Почта участника"
        placeholder="Почта участника"
        @input="changeValue($event, 'email')"
      />
      <UiInput
        v-model="filter.city"
        class="rating-header__item -l-"
        title="Город участника"
        placeholder="Город участника"
        @input="changeValue($event, 'city')"
      />
    </div>
    <div v-if="isLoadingFilters" class="rating-header__block">
      <div
        v-for="(n, index) in 2"
        :key="index"
        class="ajax__line -round-"
        :style="{ height: '58px', width: '210px', margin: '2px 2px' }"
      />
    </div>
    <div v-else class="rating-header__block">
      <UiInput
        v-model="filter.captainName"
        class="rating-header__item -m-"
        title="Имя капитана"
        placeholder="Имя капитана"
        @input="changeValue($event, 'captainName')"
      />
      <UiSelect
        ref="courseName"
        v-model="filter.facultyId"
        class="rating-header__item -l-"
        title="Выбор факультета"
        placeholder="Выбор факультета"
        :option="localFaculties"
        :can-unset="false"
        :unset-value="null"
        @input="changeValue($event, 'facultyId')"
      />
    </div>
  </Header>
</template>

<script>
import Header from '../../components/Header';
import { mapActions, mapState, mapMutations } from 'vuex';
import replaceRouteQuery from '@/functions/replaceMultipleRouteQuery';

export default {
  components: {
    Header
  },
  data() {
    return {
      filter: {
        amoProducts: ['Скорость Клуб 2'], // Дефолтно выставлены на бэке, тут для того чтобы пользователь понимал это
        courseName: 'Скорость Клуб 2', // Дефолтно выставлены на бэке, тут для того чтобы пользователь понимал это
        budgetMin: null,
        budgetMax: null,
        revenueMin: null,
        revenueMax: null,
        name: null,
        email: null,
        city: null,
        captainName: null,
        facultyId: null
      }
    };
  },
  computed: {
    ...mapState('ratingSpeedAndHundred', {
      amoProducts: s => s.data.amoProducts,
      courseStreams: s => s.data.courseStreams,
      faculties: s => s.data.faculties,
      isLoadingFilters: s => s.meta.isLoadingFilters
    }),
    placeholderProducts() {
      if (this.filter.amoProducts.length === 1) {
        return this.filter.amoProducts[0];
      }

      return this.filter.amoProducts.length
        ? 'Выбрано ' + this.filter.amoProducts.length
        : 'Ничего не выбрано';
    },
    localCourseStreams() {
      return this.courseStreams
        ? this.courseStreams.map(item => {
            return {
              title: item.name,
              value: item.name
            };
          })
        : [];
    },
    localFaculties() {
      return this.faculties
        ? this.faculties.map(item => {
            return {
              title: item.name,
              value: item.id + ''
            };
          })
        : [];
    }
  },
  watch: {
    filter: {
      handler(value, oldVal) {
        if (!value.amoProducts.length || !value.courseName) {
          if (
            !value.amoProducts.length &&
            oldVal.courseName !== '' &&
            oldVal.courseName !== null
          ) {
            this.$refs.amoProducts.$el.classList.add('-error-');
          } else if (!value.courseName && oldVal.amoProducts.length !== 0) {
            this.$refs.courseName.$el.classList.add('-error-');
          }
        } else {
          this.$refs.amoProducts.$el.classList.remove('-error-');
          this.$refs.courseName.$el.classList.remove('-error-');
        }
      },
      deep: true
    }
  },
  created() {
    this.initFilter();
  },
  async mounted() {
    this.setMeta({ path: 'isLoadingFilters', value: true });
    await this.getDictionary();
    this.setCurrentStream(this.filter.courseName);
  },
  methods: {
    ...mapActions('ratingSpeedAndHundred', ['getDictionary', 'setMeta']),
    ...mapMutations('ratingSpeedAndHundred', ['setCurrentStream']),
    initFilter() {
      const query = this.$route.query;
      const filter = this.filter;

      this.filter.amoProducts = query['amoProducts']
        ? JSON.parse(query['amoProducts'])
        : filter.amoProducts;
      this.filter.courseName = query['courseName']
        ? query['courseName']
        : filter.courseName;
      this.filter.budgetMin = query['budgetMin'] || filter.budgetMin;
      this.filter.budgetMax = query['budgetMax'] || filter.budgetMax;
      this.filter.revenueMin = query['revenueMin'] || filter.revenueMin;
      this.filter.revenueMax = query['revenueMax'] || filter.revenueMax;
      this.filter.name = query['name'] || filter.name;
      this.filter.email = query['email'] || filter.email;
      this.filter.city = query['city'] || filter.city;
      this.filter.captainName = query['captainName'] || filter.captainName;
      this.filter.facultyId = query['facultyId'] || filter.facultyId;
    },
    changeValue(value, name) {
      const obj = {};
      if (this.checkProductAndCourse(value, name)) {
        return;
      } else if (name === 'amoProducts' || name === 'courseName') {
        obj['amoProducts'] = JSON.stringify(this.filter.amoProducts);
        obj['courseName'] = this.filter.courseName;
        if (name === 'courseName') {
          this.setCurrentStream(this.filter.courseName);
          this.getDictionary(); // Для получение новых факультетов
        }
      } else {
        obj[name] = value;
      }

      const arrQuery = Object.entries({ ...this.$route.query, ...obj }).map(
        el => ({
          method: 'replace',
          name: el[0],
          value: el[1]
        })
      );

      if (this.checkRouterEqual(arrQuery)) {
        return;
      }

      replaceRouteQuery(arrQuery);
    },
    checkRouterEqual(arrQuery) {
      return !arrQuery.find(
        param => param.value != this.$route.query[param.name]
      );
    },
    checkProductAndCourse(value, name) {
      if (name === 'amoProducts' || name === 'courseName') {
        if (!this.filter.amoProducts.length && !this.filter.courseName) {
          return true;
        }

        if (
          (this.filter.amoProducts.length && !this.filter.courseName) ||
          (!this.filter.amoProducts.length && this.filter.courseName)
        ) {
          return true;
        }
      }

      return false;
    }
  }
};
</script>
